import React, { useState } from 'react';
import { Button, Row, Col } from 'antd';

import QuestionnaireItem from '../QuestionnaireItem';
import BasePageCard from 'components/wrappers/BasePageCard';
import { AssignmentDetailsModel } from 'utils/assignmentUtils';
import { AssignmentQuestionnaireInfoModel } from 'api/adminApiClient';
import { isAdminSelector } from 'redux/selectors/authenticationSelectors';
import { ClassificationQuestionnaireModal } from 'features/assignment/Questionnaire/QuestionnaireModals';
import { useAppSelector } from 'hooks/useAppSelector';

import styles from './ClassificationQuestionnaireSection.module.less';

type Props = {
  assignmentId?: string;
  assignmentKey?: string;
  questionnaireInfo: AssignmentQuestionnaireInfoModel;
  setPrimaryDetails?: (data: AssignmentDetailsModel) => void;
};

export default function ClassificationQuestionnaireSection(props: Props) {
  const {
    assignmentId = '',
    assignmentKey = '',
    questionnaireInfo,
    setPrimaryDetails,
  } = props;
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const isAdmin = useAppSelector(isAdminSelector);

  return (
    <>
      {isEditModalVisible && setPrimaryDetails && (
        <ClassificationQuestionnaireModal
          isAdmin={isAdmin}
          isEditMode={true}
          assignmentId={assignmentId}
          assignmentKey={assignmentKey}
          questionnaireInfo={questionnaireInfo}
          onClose={() => setIsEditModalVisible(false)}
          setPrimaryDetails={setPrimaryDetails}
        />
      )}
      <Col xs={24} className="d-flex">
        <BasePageCard
          className="stretch-card"
          title="Classification questionnaire"
          icons={<span className="icon icon-classification-questionnaire" />}
          subTitle={
            isAdmin && (
              <Button
                onClick={() => setIsEditModalVisible(true)}
                className="with-icon mobile-icon-only"
                size="large"
                icon={<span className="icon icon-edit" />}
              >
                Edit
              </Button>
            )
          }
        >
          <div className="content-wrapper">
            <Row gutter={[20, 20]}>
              <Col xs={24} md={12} className={styles.rightBlock}>
                <Row gutter={[5, 5]}>
                  <Col
                    xs={24}
                    data-id="classificationQuestionnaireOngoingTrainingRequired"
                  >
                    <QuestionnaireItem
                      title="With the exception of initial project orientation, does the customer require the worker to undergo ongoing training?:"
                      questionnaireItem={
                        questionnaireInfo?.ongoingTrainingRequired
                      }
                    />
                  </Col>

                  <Col
                    xs={24}
                    data-id="classificationQuestionnaireClockInOrOutDictated"
                  >
                    <QuestionnaireItem
                      title="Clock in or out dictated:"
                      questionnaireItem={
                        questionnaireInfo?.clockInOrOutDictated
                      }
                    />
                  </Col>

                  <Col
                    xs={24}
                    data-id="classificationQuestionnaireSuppliesProvision"
                  >
                    <QuestionnaireItem
                      title="Supplies provision:"
                      questionnaireItem={questionnaireInfo?.suppliesProvision}
                    />
                  </Col>

                  <Col
                    xs={24}
                    data-id="classificationQuestionnaireSpecializedSkillsetEmployeeAvailbility"
                  >
                    <QuestionnaireItem
                      title="Specialized skillset employee availability:"
                      questionnaireItem={
                        questionnaireInfo?.specializedSkillsetEmployeeAvailbility
                      }
                    />
                  </Col>

                  <Col
                    xs={24}
                    data-id="classificationQuestionnaireWorkerPerformedSimilarServices"
                  >
                    <QuestionnaireItem
                      title="Contractor performed similar services:"
                      questionnaireItem={
                        questionnaireInfo?.workerPerformedSimilarServices
                      }
                    />
                  </Col>
                </Row>
              </Col>

              <Col xs={24} md={12}>
                <Row gutter={[5, 5]}>
                  <Col
                    xs={24}
                    data-id="classificationQuestionnaireCustomerControl"
                  >
                    <QuestionnaireItem
                      title="Customer control:"
                      questionnaireItem={questionnaireInfo?.customerControl}
                    />
                  </Col>

                  <Col
                    xs={24}
                    data-id="classificationQuestionnaireSupervisionOfWorker"
                  >
                    <QuestionnaireItem
                      title="Contractor supervised by customer:"
                      questionnaireItem={questionnaireInfo?.supervisionOfWorker}
                    />
                  </Col>

                  <Col
                    xs={24}
                    data-id="classificationQuestionnaireBusinessExpensesReimbursed"
                  >
                    <QuestionnaireItem
                      title="Business expenses reimbursed:"
                      questionnaireItem={
                        questionnaireInfo?.businessExpensesReimbursed
                      }
                    />
                  </Col>

                  <Col
                    xs={24}
                    data-id="classificationQuestionnaireServicesAreKeyAspectOfBM"
                  >
                    <QuestionnaireItem
                      title="Services are key aspect of BM:"
                      questionnaireItem={
                        questionnaireInfo?.servicesAreKeyAspectOfBM
                      }
                    />
                  </Col>

                  <Col
                    xs={24}
                    data-id="classificationQuestionnaireServicesAdvertisedByWorker"
                  >
                    <QuestionnaireItem
                      title="Services advertised by worker:"
                      questionnaireItem={
                        questionnaireInfo?.servicesAdvertisedByWorker
                      }
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </BasePageCard>
      </Col>
    </>
  );
}
